"use client";

import { LoginForm } from "@/components/login-form";

export default function LoginPage() {
	return <LoginForm />;
}
